/**
 * Manufacturer Page Script
 * @description Script para página de fabricante/marca
 * @version 1.0.0
 * @author Irroba Platform
 */

// Importar módulos globais comuns
import LazyLoading from '../functions/lazy-loading.js';
import { generateTemplateContent, parseToHtml, replaceString } from '../functions/html_element.js';
import { setCacheData, getCacheData } from '../functions/cache.js';
import { initGlobalComponents } from '../modules/global-components.js';
import { initProductListsNearViewport } from '../modules/product_list_module.js';

/**
 * Inicialização da página de fabricante
 */
const initManufacturerPage = () => {
    console.log('🚀 Inicializando página de fabricante...');

    try {
        // Inicializar componentes comuns
        initGlobalComponents();
        initProductListsNearViewport();
        initLazyLoading();

        // Funcionalidades específicas do fabricante
        initBrandInfo();
        initFilters();
        initSorting();
        initPagination();

        console.log('✅ Página de fabricante inicializada com sucesso!');
    } catch (error) {
        console.error('❌ Erro ao inicializar página de fabricante:', error);
    }
};

/**
 * Inicializa Lazy Loading de imagens
 */
const initLazyLoading = () => {
    try {
        new LazyLoading({
            selector: 'img[data-src]',
            rootMargin: '50px'
        });
        console.log('✅ Lazy Loading inicializado');
    } catch (error) {
        console.warn('Erro ao inicializar Lazy Loading:', error);
    }
};

/**
 * Inicializa informações da marca
 */
const initBrandInfo = () => {
    const brandDescToggle = document.querySelector('[data-brand-desc-toggle]');
    const brandDesc = document.querySelector('[data-brand-description]');
    
    if (brandDescToggle && brandDesc) {
        brandDescToggle.addEventListener('click', function() {
            brandDesc.classList.toggle('expanded');
            const isExpanded = brandDesc.classList.contains('expanded');
            this.textContent = isExpanded ? 'Ver menos' : 'Ver mais';
            console.log('📝 Descrição da marca', isExpanded ? 'expandida' : 'recolhida');
        });
    }
};

/**
 * Inicializa sistema de filtros
 */
const initFilters = () => {
    const filterToggles = document.querySelectorAll('[data-filter-toggle]');
    
    filterToggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            const filterPanel = document.querySelector('[data-filter-panel]');
            if (filterPanel) {
                filterPanel.classList.toggle('active');
                console.log('📊 Filtros alternados');
            }
        });
    });

    // Aplicar filtros
    const filterInputs = document.querySelectorAll('[data-filter-input]');
    filterInputs.forEach(input => {
        input.addEventListener('change', function() {
            console.log('🔍 Filtro aplicado:', this.name, this.value);
            // Implementar lógica de aplicação de filtro
        });
    });
};

/**
 * Inicializa sistema de ordenação
 */
const initSorting = () => {
    const sortSelect = document.querySelector('[data-sort-select]');
    
    if (sortSelect) {
        sortSelect.addEventListener('change', function() {
            const sortValue = this.value;
            console.log('📋 Ordenação selecionada:', sortValue);
            // Implementar lógica de ordenação
        });
    }
};

/**
 * Inicializa paginação
 */
const initPagination = () => {
    const paginationLinks = document.querySelectorAll('[data-pagination-link]');
    
    paginationLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const page = this.dataset.paginationLink;
            console.log('📄 Navegando para página:', page);
            // Ajax pagination pode ser implementado aqui
        });
    });
};

/**
 * Inicializa quando o DOM estiver pronto
 */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initManufacturerPage);
} else {
    initManufacturerPage();
}

export default {
    init: initManufacturerPage
};
